import Grid2 from '@mui/material/Unstable_Grid2';
import React from 'react';

interface IconWithTextProps {
  children: React.ReactNode;
  centered?: boolean;
  onClick?: () => void;
  gap?: number;
}
export const IconWithText = ({ children, centered, onClick, gap=5 }: IconWithTextProps) => {
  let style: React.CSSProperties = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: onClick ? 'pointer' : 'default',
    gap: gap,
    margin: 0,
    padding: 0,
  };
  if (centered) style = { ...style, justifyContent: 'center' };
  return <div style={style} onClick={onClick}>{children}</div>;
};

export const mobileDoubleItemsGrid = (children: React.ReactNode[]) => {
  return (
    <Grid2 spacing={0.5} container>
      {children.map((child, index) => (
        <Grid2
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          key={index}
          xs={6}
        >
          {child}
        </Grid2>
      ))}
    </Grid2>
  );
};
